const types = {
  MENU_IS_SHOW: "MENU_IS_SHOW",
};
const menu = {
  state: {
    sidebarIsShow: false,
    sidebarWidth: 0,
  },
  getters: {
    menuIsShow: (state) => {
      return state.sidebarIsShow;
    },
    sidebarWidth: (state) => {
      return state.sidebarWidth;
    },
  },
  mutations: {
    [types.MENU_IS_SHOW](state, payload) {
      state.sidebarIsShow = payload;
    },
  },
  actions: {
    setMenuBar: ({ commit }, opt) => {
      commit(types.MENU_IS_SHOW, opt);
    },
  },
};

export default menu;
